/*!
 * This component may not be reversed engineered for hacking or abuse
 * of The EGT Universe, The Universe, or third-party apps.
 * 
 * Written for:
 * Stallion.
 * Payments by The Universe
 * Universe App Modules
 * 
 * Justin K Kazmierczak
 * 
 * Build's a module's individual components based on it's definition.
 * 
 * Modified from uam.fields for module
 * 
 **/
/*!
 *
 */

// var fields = require("./fields.js");

var namespace = "fields.module";
var errModule = require("./errors.js");
var acceptableFieldTypes = [
    "field",
    "attribute"
];

var _ = {
    errors: {}
};

// var errModule = require("./errors.js");
var GenerateStacktrace = require("./functions/generateStacktrace.js").function;
// var config = false;
// var registryFactory = require("./registry.js");
// var validate = require("./functions/validate.js").function;
var generateSafeError = require("./functions/generateSafeError.js").function;
// var supportedTypes = require("./functions/validate.js").supportedTypes;
var fm = false;

try {
    fm = require("./filemanager.js"); //Won't work in the browser.
} catch (error) {
    //not supported in browser
}


//add the errors
_.errors = errModule.createFromDefine({
    namespace: namespace,
    errors: {
        noNamespace: {
            title: "No Namespace",
            description: "The module does not have a namespace."
        },
        noTitle: {
            title: "No Title",
            description: "The module does not have a title."
        },
        noDescription: {
            title: "No Description",
            description: "The module does not have a description."
        },
        noType: {
            title: "No Type",
            description: "The module does not have a type."
        },
        invalidType: {
            title: "Invalid Type",
            description: "The module type is invalid."
        }
    }
});

// var GenerateStacktrace = require("./functions/generateStacktrace.js").function;
// var config = false;
// var registryFactory = require("./registry.js");
// var validate = require("./functions/validate.js").function;
// var generateSafeError = require("./functions/generateSafeError.js").function;
// var supportedTypes = require("./functions/validate.js").supportedTypes;
// var fm = false;

// var errors = [];
// var fields = registryFactory("uam.fields");

// try {
//     config = require("./config.js");
//     // fm = require("./filemanager.js"); //Won't work in the browser.
//     // fm.SaveLogJSONbyNamespaceItem()
// } catch (error) {
//     // console.error("The module can not import config due to a circuluar refrence.", error);
//     //config is disabled for client side modules.
// }
// // var config = require("./config.js");

// try {
//     fm = require("./filemanager.js"); //Won't work in the browser.
// // fm.SaveLogJSONbyNamespaceItem()
// } catch (error) {
//     // console.error("Access to file manager is denied for this module.", error);
// //config is disabled for client side modules.
// }

/**
 * WARNING, Specific to fields only. NO Config! (Errros are allowed)
 * Builds a module based on it's definition.
 * @param {*} exp The module.exports object.
 * @param {*} define The definition object.
 * @param {*} define.namespace The namespace of the module.
 * @param {*} define.title The title of the module.
 * @param {*} define.description The description of the module.
 * @param {*} define.errors The errors of the module.
 * @param {*} define.alias The alias of the module. Can be a string or an array of strings.
 * @param {*} define.type The type of the field, can be "base" or "object".
 * @param {*} define.use The use object passed to the editor. Can default to a specific namespace with values and such passed through.
 * @param {*} define.fields The fields of the module.
 * @param {*} define.fields.namespace The namespace field, automatically added based ont he object property name and the namespace.
 * @param {*} define.fields.title The title field.
 * @param {*} define.fields.description The description field.
 * @param {*} define.fields.type The type field.
 * @param {*} define.fields.list The list field.
 * @param {*} define.fields.default The default field.
 * @param {*} define.fields.required The required field.
 * @returns The module.exports object (can also be used as a _ object).
 */
function Create(exp, define) {

    var errs = [];

     try {
            
        if (!("namespace" in define)) {
            _.errors.noNamespace.throw(define);
        }

        if (!("title" in define)) {
            _.errors.noTitle.throw(define);
        }

        if (!("description" in define)) {
            _.errors.noDescription.throw(define);
        }

        //check that the type is base or object
        if (!("type" in define)) {
            _.errors.noType.throw(define);
        }

        if (!(acceptableFieldTypes.includes(define.type))) {
            _.errors.invalidType.throw(define);
        } exp.type = define.type;

        // SaveDefin(define);

        exp.namespace = define.namespace;
        exp.define = define;

        if ("errors" in define) {

            // try {
                exp.errors = errModule.createFromDefine(define);            
            // } catch (error) {
                // errs.push(error);
            // }

        }

        //if tests
        if ("tests" in define) {
            exp.tests = BuildTests(define);
        }

        // //get property count of exp.errors
        // var errorCount = Object.keys(exp.errors).length;
        
        // if ("fields" in define) {

        //     // fields.ValidateSpec

        // }

     } catch (error) {

        console.error(error);
        errs.push(error);


     }

     SaveDefin(define, errs);

     if (!(errs.length === 0)) {
        //throw the errors
        throw errs[0]
     }

    
    return exp;
} module.exports = Create;

/**
 * Saves the definition to the file manager.
 * @param {*} define The definition object.
 * @param {*} errs The errors that occured.
 */
function SaveDefin(define, errs = false) {
    if (fm) {

        var nDefine = {...define};
        nDefine.compile = {
            errors: false
        }

        if (errs) {

            if (errs.length > 0) {

                //for each error add it to the compile errors after converting it with generateSafeError
                nDefine.compile.errors = errs.map(function(err) {
                    return generateSafeError(err);
                });
    
                var messages = nDefine.compile.errors.map(function(err) {
                    return err.message;
                });

                console.warn(`${define.namespace} failed to compile. Reasons: ${messages.join(" ")}`);
                fm.SaveLogJSONbyNamespaceItem("fields.errors", nDefine);

                // add this object to allErrors 
                // allErrors[define.namespace] = errs;
                // fm.SaveLogJSON("fields.allerrors", allErrors);

                // nDefine.compile.errors = errs;
            }
        }

        nDefine.from = GenerateStacktrace(0);

        try {
            fm.SaveLogJSON(nDefine.namespace, nDefine, namespace);
        } catch (error) {
            
        }

        // if (errs) {
        //     if (errs.length > 0) {

        //         //get all messages
        //         var messages = errs.map(function(err) {
        //             return err.message;
        //         });

        //         console.warn(`${define.namespace} failed to compile. Reasons: ${messages.join(" ")}`);
        //         fm.SaveLogJSONbyNamespaceItem("build.errors", nDefine);

        //     }
        // }


    }
}

//convert test object prop names to array from
// {
//     "this": {
//         ...
//     }
// }
// to
// [
//     {
//         namespace: "namespace.this",
//         ...
//     }
// ]

/**
 * Builds the tests array from a define shcema.
 * @param {*} define The definition object.
 * @returns The tests array.
 */
function BuildTests(define) {
    var tests = [];

    for (var test in define.tests) {
        var nTest = {...define.tests[test]};
        nTest.namespace = define.namespace + "." + test;
        tests.push(nTest);
    }

    return tests;
}